import "./home.css";
import me from "../../assets/images/mypic.jpg"

const Home = () => {
  return (<div>
    <div className="h">
      <div className="h-left">
        <div className="h-left-wrapper">
          <h2 className="h-intro">Hello, My name is</h2>
          <h1 className="h-name">Husain</h1>
          <div className="h-title">
            <div className="h-title-wrapper">
              <div className="h-title-item">Web Developer</div>
              <div className="h-title-item">UI/UX Designer</div>
              <div className="h-title-item">Writer</div>
              <div className="h-title-item">Content Creator</div>
            </div>
          </div>
          <h7 className="h-desc">
            I design and develop services for customers of all sizes,
            specializing in creating stylish, modern websites, web services and
            online stores.
          </h7>
        </div>

      </div>
      <div className="h-right">
        <div className="h-bg"></div>
        <img src={me} alt="" className="h-img" />
      </div>
    </div>
    {/* about section start */}
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img
            src={me}
            alt=""
            className="a-img"
          />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About Me</h1>
        <p className="a-sub">
          It is a long established fact that a reader will be distracted by the
          readable content.
        </p>
        <p className="a-desc">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat duis aute irure dolor in reprehende.
        </p>
        <div className="a-award">
          <img src={me} alt="" className="a-award-img" />
          <div className="a-award-texts">
            <h4 className="a-award-title">International Design Awards 2021</h4>
            <p className="a-award-desc">
              Nemo enim ipsam voluptatem quia voluptas sit aspernatur autodit
              and fugit.
            </p>
          </div>
        </div>
      </div>
    </div>
</div>
  );
};

export default Home;
